import React from 'react';
import { useSelector } from 'react-redux';
import { State } from 'store/types';
import DnWidgets from '../dnWidgets';
import Popular from '../Popular';
import { PopularSuggestion } from 'types/searchSuggestion';
import { SEARCH_DN_WIDGETS } from 'constants/experiments';
import { getEligibleForVariant } from 'helpers/experimentV2';

interface Props {
  handlePopularSearchClick: (
    suggestion: PopularSuggestion,
    position: number
  ) => void;
}

const PopularSuggestions = ({ handlePopularSearchClick }: Props) => {
  const showDnWidgets = useSelector((state: State) =>
    getEligibleForVariant(state, SEARCH_DN_WIDGETS, 'A')
  );

  if (showDnWidgets) {
    return <DnWidgets />;
  }

  return <Popular handleClick={handlePopularSearchClick} />;
};

export default PopularSuggestions;
